"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMeterAsync = exports.getLogger = void 0;
const client_1 = require("@ebay/rum-web/client");
Object.defineProperty(exports, "getLogger", { enumerable: true, get: function () { return client_1.getLogger; } });
Object.defineProperty(exports, "getMeterAsync", { enumerable: true, get: function () { return client_1.getMeterAsync; } });
